<template>
  <!-- prettier-ignore -->
  <svg aria-hidden="true" focusable="false" width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m4.99 10 .96-.95L2.6 5.7H11V4.3H2.6L5.96.96 4.99 0 0 5l4.99 5Z" fill="currentColor"/></svg>
</template>
